import { throwApiError } from 'src/packages/errors/utils';

import type { AxiosInstance } from 'axios';

export class RefreshLogsApi {
  constructor(private readonly gatewayAgent: AxiosInstance) {}

  enrichByWellIds = async (wellIds: number[]) => {
    try {
      await this.gatewayAgent.put('/api/v2/logs/enrichByWellIds', wellIds);
    } catch (error) {
      throwApiError(error);
    }
  };
}
